import Bugsnag from "@bugsnag/js";
import versions from "./versions.json" assert { type: "json" };
export async function initBugsnag(bugSnagApiKey) {
    Bugsnag.start({
        apiKey: bugSnagApiKey,
        endpoints: {
            notify: "https://exceptions.coinbase.com",
            sessions: "https://sessions.coinbase.com"
        },
        releaseStage: process.env.WAAS_ENV,
        appVersion: versions.waasSdkWeb,
        autoDetectErrors: true
    });
    Bugsnag.addMetadata("versionInfo", {
        waas_sdk_version: versions.waasSdkWeb,
        corekms_sdk_version: versions.corekms
    });
}
export function logInfo(error, data) {
    Bugsnag.notify(error, (event) => {
        if (data) {
            const { context, metadata } = data;
            if (metadata) {
                metadata.map(tab => event.addMetadata(tab.name, tab.data));
            }
            event.context = context;
        }
        event.severity = "info";
    });
}
export function logWarning(error, data) {
    Bugsnag.notify(error, (event) => {
        if (data) {
            const { context, metadata } = data;
            if (metadata) {
                metadata.map(tab => event.addMetadata(tab.name, tab.data));
            }
            event.context = context;
        }
        event.severity = "warning";
    });
}
export function logError(error, data) {
    Bugsnag.notify(error, (event) => {
        if (data) {
            const { context, metadata } = data;
            if (metadata) {
                metadata.map(tab => event.addMetadata(tab.name, tab.data));
            }
            event.context = context;
        }
        event.severity = "error";
    });
}
